export enum MESSAGE_EVENT {
  SEND_PRIVATE_MESSAGE = "SEND_PRIVATE_MESSAGE",
  SEND_GROUP_MESSAGE = "SEND_GROUP_MESSAGE",
  GET_CURRENT_USER = "GET_USER_ID",
  MESSAGE_SENT = "MESSAGE_SENT",
  GROUP_UPDATE = "UPDATE_GROUP",
  REFRESH_CHAT_COUNTER = "REFRESH_CHAT_COUNTER",
}
